import cn from 'classnames';

import PulseTriangle from './PulsingTriangles/PulsingTriangles';

import styles from './styles.module.scss';

export type PulseProps = {
  position?: {
    top?: string;
    left?: string;
    bottom?: string;
    right?: string;
  };
  direction: 'up' | 'right' | 'down' | 'left';
  testId: string;
};

export const Pulse = ({ position, direction, testId }: PulseProps) => {
  return (
    <div
      className={cn(styles.pulse, styles[direction])}
      style={{
        top: position?.top,
        left: position?.left,
        right: position?.right,
        bottom: position?.bottom,
      }}
      data-testid={`onboarding-${testId}-pulse`}
    >
      <PulseTriangle />
    </div>
  );
};
